import { MiniCartStyleTokens } from "@omni/ui/brand/cart/miniCart/miniCart.tokens";

export const MiniCartStyles: MiniCartStyleTokens = {
    orderButton: {
        color: "primary"
    }
};
